// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"865cd073","952":"195ec2ec"}[chunkId] + ".chunk.js";
};